


import React from 'react'
import Image2withBG from "../../assets/borrower-page/Image2withBG.svg";
import { Box, Grid, Typography } from "@mui/material";
import Background from "../../assets/borrower-page/Background.svg";

export default function DocCollection() {
    return (
        <Grid container justifyContent="center" spacing={0}> {/* Center align with spacing */}
            <Grid item xs={11} md={11} lg={11} mt={0} mb={0} ml={0} mr={0} > {/* Apply margins here */}
                <div>
                    <Box>
                        <Grid
                            container
                            minHeight="30vh"
                            alignItems="top"
                        //  pt={{ xs: 4, md: 1 }}
                        >
                            {/* Image Grid */}
                            {/* Background Image with Overlay */}
                            <Grid item xs={12} md={5} order={{ xs: 2, md: 1 }}> {/* Image second on mobile */}
                                <Box position="relative" my={{ md: "none", xs: 2 }}>
                                    {/* Background Image */}
                                    <img src={Background} width="100%" height="100%" alt="Background" />

                                    {/* Overlay Image */}
                                    <img
                                        src={Image2withBG} width={"100%"}
                                        style={{
                                            position: "absolute",
                                            bottom: 0, // Align to the bottom of the parent container
                                            left: "50%", // Center horizontally
                                            transform: "translateX(-50%)" // Adjust horizontally to center
                                        }}
                                        alt="Overlay Image"
                                    />
                                </Box>
                            </Grid>

                            <Grid item md={2} order={{ xs: 3, md: 2 }}></Grid>

                            {/* Text Grid */}
                            <Grid
                                item
                                xs={12}
                                md={5}
                                textAlign={{ xs: "center", md: "start" }}
                                px={{ xs: 2 }}
                                order={{ xs: 1, md: 3 }}
                            >
                                <Typography
                                    variant="h2"
                                    component="h1"
                                    mb={2} mt={0}
                                    fontWeight={"bold"}
                                    lineHeight={"50px"}
                                >
                                    {`Intelligent Document Collection `}
                                </Typography>
                                <Typography variant="body1" mb={1}>
                                    {`Our streamlined process uses advanced technology to collect and organize your essential documents efficiently, reducing paperwork and hassle. Experience a smarter, faster way to complete your mortgage application.`}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </Grid>
        </Grid>
    )
}
